import React from 'react';

class Contractor extends React.Component {
  render() {
    const { onClick } = this.props;
    return (
      <button className="contractor" onClick={onClick}>
        <img src="/assets/hnav/minus.png" size="11x11" />
      </button>
    );
  }
}

export default Contractor;
